import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { useUnreadCount } from "@/lib/useUnreadCount";

/**
 * Top-nav inbox link with an unread-count badge.
 *
 * iter150-review — Now subscribes to the shared useUnreadCount() hook
 * so this bell, the mobile AppHeader bell and the mobile BottomNav
 * Inbox tile always show the same number. Role filtering happens on
 * the backend (`/api/inbox/unread-count` returns unreadSchool for
 * schools, unreadAdmin for admins — the two are never summed).
 *
 * Destination differs by role: schools go to /inbox, admins jump to
 * the Admin Dashboard's Inbox tab via /admin?tab=inbox.
 */
export default function InboxBell({ role, isActive }) {
  const unread = useUnreadCount();
  const to = role === "admin" ? "/admin?tab=inbox" : "/inbox";
  return (
    <Link
      to={to}
      data-testid="nav-inbox"
      className={`relative flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-all duration-200 ${
        isActive ? "bg-clay text-white" : "text-ink-700 hover:bg-sand-100 hover:text-ink-900"
      }`}
    >
      <Mail className="h-3.5 w-3.5" />
      <span>Inbox</span>
      {unread > 0 && (
        <span
          data-testid="nav-inbox-unread-badge"
          className="absolute -right-1 -top-1 grid h-4 min-w-[16px] place-items-center rounded-full bg-red-600 px-1 text-[10px] font-bold text-white shadow-sm"
        >{unread > 99 ? "99+" : unread}</span>
      )}
    </Link>
  );
}
